import { render, staticRenderFns } from "./Yardage.vue?vue&type=template&id=2a90728b"
import script from "./Yardage.vue?vue&type=script&lang=js"
export * from "./Yardage.vue?vue&type=script&lang=js"
import style0 from "./Yardage.vue?vue&type=style&index=0&id=2a90728b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports